import React, { useEffect, useState } from 'react';
import { WifiOff, SignalLow } from 'lucide-react';
import { useNetworkQuality } from '../services/networkQuality';

// Bandeau persistant : hors-ligne (rouge) ou signal faible (ambre, rafraîchissements non essentiels en pause).
const OfflineBanner = () => {
  const { online, weak, reason } = useNetworkQuality();
  const [recentError, setRecentError] = useState(false);
  const [pendingSpots, setPendingSpots] = useState(0);

  useEffect(() => {
    const onPending = (e) => setPendingSpots(e.detail?.count || 0);
    let errTimer = null;
    const onApiOffline = () => {
      setRecentError(true);
      if (errTimer) clearTimeout(errTimer);
      errTimer = setTimeout(() => setRecentError(false), 60000);
    };
    window.addEventListener('obgh:offline', onApiOffline);
    window.addEventListener('obgh:pending-spots', onPending);
    return () => {
      window.removeEventListener('obgh:offline', onApiOffline);
      window.removeEventListener('obgh:pending-spots', onPending);
      if (errTimer) clearTimeout(errTimer);
    };
  }, []);

  const visible = !online || weak || recentError || pendingSpots > 0;
  if (!visible) return null;

  const isFullyOffline = !online;
  const pendingLabel = pendingSpots > 0 ? ` · ${pendingSpots} pin${pendingSpots > 1 ? 's' : ''} en attente de sync` : '';
  const weakLabel = `Signal faible${reason ? ` (${reason})` : ''} — carte/GPS OK, météo en pause`;

  return (
    <div
      data-testid="offline-banner"
      data-weak={weak ? '1' : '0'}
      className={`fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2 px-3 pb-1 text-[10px] lg:text-[11px] font-bold uppercase tracking-wider shadow-md ${
        isFullyOffline ? 'bg-red-600/95 text-white' : 'bg-amber-500/95 text-black'
      }`}
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.25rem)' }}
    >
      {isFullyOffline ? <WifiOff size={14} /> : <SignalLow size={14} />}
      <span>
        {isFullyOffline
          ? `Mode hors-ligne — données en cache uniquement${pendingLabel}`
          : weak || recentError
            ? `${weakLabel}${pendingLabel}`
            : `Synchronisation${pendingLabel}`}
      </span>
    </div>
  );
};

export default OfflineBanner;
